var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", {
    attrs: {
      "data-type": _vm.nodeType
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("理赔单信息")))])]), _c("div", {
    staticClass: "infoList"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("理赔类型")) + ":" + _vm._s(_vm.claimsInfo.claimsTypeName))]), _c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.claimsInfo.claimsSort, function (item, index) {
    return _c("a-card", {
      key: index,
      staticClass: "itemBox",
      attrs: {
        bordered: true,
        title: _vm.$t(item.sortName),
        hoverable: ""
      }
    }, [_vm._l(item.claimsParam, function (item2, index2) {
      return _c("div", {
        key: index2,
        staticClass: "infoItem",
        staticStyle: {
          "margin-bottom": "5px"
        }
      }, [_c("div", {
        staticClass: "left"
      }, [_vm._v(_vm._s(_vm.$t(item2.paramName)) + ":")]), _c("div", {
        staticClass: "right"
      }, [_vm._v(_vm._s(item2.paramPlaceholder))])]);
    }), item.auditOpinion2 && _vm.examine ? _c("div", {
      staticStyle: {
        color: "#ff4d4f"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("上次审核理由")) + ":" + _vm._s(item.auditOpinion2) + " ")]) : _vm._e(), _vm.examine ? _c("a-input", {
      attrs: {
        placeholder: _vm.$t("请输入") + _vm.$t("审核意见"),
        allowClear: ""
      },
      model: {
        value: item.auditOpinion,
        callback: function ($$v) {
          _vm.$set(item, "auditOpinion", $$v);
        },
        expression: "item.auditOpinion"
      }
    }) : _vm._e(), item.auditOpinion2 && (_vm.nodeType == 3 || _vm.nodeType == 6) || (_vm.status == 3 || _vm.status == 4) && !_vm.examine && item.auditOpinion2 ? _c("a-button", {
      attrs: {
        type: "linkDanger"
      }
    }, [_vm._v(_vm._s(_vm.$t("审核理由")) + ":" + _vm._s(item.auditOpinion2))]) : _vm._e()], 2);
  }), 1)]), _vm.activeUsers.length != 0 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("理赔资料")))]), _vm.isAuth("customer.claimsZip") && !_vm.examine || _vm.examine ? _c("div", {
    attrs: {
      slot: "btn"
    },
    slot: "btn"
  }, [_c("a-button", {
    on: {
      click: _vm.downloadFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下载证件资料")))])], 1) : _vm._e()]) : _vm._e(), _vm.activeUsers.length != 0 ? _c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_vm._l(_vm.activeUsers, function (item, index) {
    return _c("a-form-model-item", {
      key: index,
      staticClass: "imgBox",
      attrs: {
        label: _vm.$t(item.documentName)
      }
    }, [item.documentUrl.length != 0 && _vm.examine || !_vm.examine ? _c("a-upload", {
      staticClass: "upload-list-inline",
      attrs: {
        "file-list": item.documentUrl,
        "list-type": "picture-card",
        showUploadList: {
          showPreviewIcon: true,
          showRemoveIcon: false,
          showDownloadIcon: true
        }
      },
      on: {
        download: _vm.handleDownload,
        preview: file => _vm.handlePreview(file, index)
      }
    }) : _vm._e(), item.documentUrl.length == 0 ? _c("div", [_vm._v(_vm._s(_vm.$t("暂无")))]) : _vm._e(), item.auditOpinion2 && _vm.examine ? _c("div", {
      staticStyle: {
        color: "#ff4d4f"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("上次审核理由")) + ":" + _vm._s(item.auditOpinion2) + " ")]) : _vm._e(), _vm.examine ? _c("a-input", {
      attrs: {
        placeholder: _vm.$t("请输入") + _vm.$t("审核意见"),
        allowClear: ""
      },
      model: {
        value: item.auditOpinion,
        callback: function ($$v) {
          _vm.$set(item, "auditOpinion", $$v);
        },
        expression: "item.auditOpinion"
      }
    }) : _vm._e(), item.auditOpinion2 && (_vm.nodeType == 3 || _vm.nodeType == 6) || (_vm.status == 3 || _vm.status == 4) && !_vm.examine && item.auditOpinion2 ? _c("a-button", {
      attrs: {
        type: "linkDanger"
      }
    }, [_vm._v(_vm._s(_vm.$t("审核理由")) + ":" + _vm._s(item.auditOpinion2))]) : _vm._e()], 1);
  }), _vm.examine ? _c("a-form-item", {
    attrs: {
      "wrapper-col": {
        span: 15,
        offset: 9
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("审核")))])], 1) : _vm._e()], 2) : _vm._e(), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.fileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }), _vm.examineShow ? _c("examine-model", {
    ref: "examineForm",
    on: {
      cancel: function ($event) {
        _vm.examineShow = false;
      },
      ok: function ($event) {
        return _vm.$emit("back");
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };